import TeamDomains from '../../pages/team_domains/TeamDomains';

export default [
  {
    path: '/v2/admin/team/domains',
    name: 'admin.team_domains.index',
    component: TeamDomains,
    meta: {
      permission: 'can_edit_team',
      title: 'SSO Domains',
    },
  }
]
